import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {AdtaDeviceOverviewContext} from "../context/AdtaDeviceOverviewContext";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForTestPackage, isValidEntry, PATTERNS
} from "../../../util/Validations";

const AddAdtaSorterTestPackageModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);

    // Visual controls
    const {open, setOpen} = props;
    const [show, setShow] = useState(false);
    const [edit, setEdit] = useState(false);

    // Values
    const [scannables, setScannables] = useState("");
    const [sortZone, setSortZone] = useState("");

    // Error
    const [scannablesErr, setScannablesErr] = useState(false);
    const [sortZoneErr, setSortZoneErr] = useState(false);

    function onCloseModal() {
        setShow(false);
        setOpen(false);
        resetInputState();
    }

    const sorterTestPackage = {
        scannables: scannables,
        sortZone: sortZone
    }

    const testConfigMap = {}
    viewModel.sorterTestPackageConfig[mac].forEach((value) => {
        const key = value.scannables.join(";");
        testConfigMap[key] = {
            sortZone: value.sortZone
        };
    })

    const onClickConfirm = (sorterTestPackage, mac) => {
        if (checkModalValidationsForTestPackage(sorterTestPackage)) {
            setConfigData(sorterTestPackage, mac);
            setOpen(false);
            resetInputState();
            setShow(false);
        } else {
            setShow(true);
        }
    }

    const prefill = (scannables) => {
        if (testConfigMap.hasOwnProperty(scannables)) {
            setEdit(true);
            resetConfigErrorDetails();
            setSortZone(testConfigMap[scannables].sortZone);
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    function resetInputState() {
        setScannables("");
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    const resetConfigDetails = () => {
        setSortZone("");
    }

    const resetConfigErrorDetails = () => {
        setSortZoneErr(false);
    }

    const setConfigData = (sorterTestPackage, mac) => {
        sorterTestPackage.scannables = sorterTestPackage.scannables.trim().split(';').filter(Boolean);
        dispatch({type: 'ADD_TEST_PACKAGE_DATA', data: {dispatcher: dispatch, sorterTestPackage: sorterTestPackage, mac: mac}})
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "config.addupdatetest"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> <FormattedMessage id="modal.addheadingtest"
                                              defaultMessage="To edit an existing configuration, enter its Sort Zone."/>
                        </b>
                        <br/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.scannables" defaultMessage="Scannables"/>
                        </Text>
                        <Input id="scannables-input"
                               value={scannables}
                               onChange={(value) => {setScannables(value.replace(/\s/g, ''));}}
                               onBlur={() => {
                                   setScannablesErr(!isValidEntry(scannables, PATTERNS.SCANNABLE));
                                   prefill(scannables)
                               }}
                               error={scannablesErr}
                               helperText={"Tracking/Shipment ID. Separate multiple values by semicolon (;)"}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            <FormattedMessage id="modal.sortzone"
                                              defaultMessage="Sort Zone"/>
                        </Text>
                        <Input id="sort-zone-input"
                               value={sortZone}
                               onChange={setSortZone}
                               onBlur={() => {setSortZoneErr(!isValidEntry(sortZone, PATTERNS.SORT_ZONE))}}
                               error={sortZoneErr}
                               helperText={"eg. EU: A1-1A, NA: A-1.1A"}/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForTestPackage(sorterTestPackage) &&
                            show &&
                            <Alert type="warning" size="small">
                                <FormattedMessage id="alert.missingfields"
                                                  defaultMessage="Please enter all fields in correct format!"/>
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(sorterTestPackage, mac)}>
                            { edit ? <FormattedMessage id="modal.confirmUpdate" defaultMessage="Confirm update"/>
                                : <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddAdtaSorterTestPackageModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/modal/AddAdtaSorterTestPackageModal.js